import React from 'react';
import styled from 'styled-components';

import theme from '../../../../styled-components/dark';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${theme.MissionRequirementTag.backgroundColor};
  border-radius: 0.5em;
  padding: 0 0.67em 0;
`;

const Label = styled.div`
  color: ${theme.MissionRequirementTag.labelColor};
  white-space: nowrap;
  font-size: 0.8em;
`;

const Value = styled.div`
  color: ${theme.MissionRequirementTag.valueColor};
  font-weight: bold;
`;

type MissionRequirementTagProps = {
  label: string;
  value: string;
};

const MissionRequirementTag = ({ label, value }: MissionRequirementTagProps) => {
  return (
    <Wrapper>
      <Label>{label}</Label>
      <Value>&nbsp;{value}</Value>
    </Wrapper>
  );
};

export default MissionRequirementTag;
